import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-callout',
  templateUrl: './gb-callout.component.html',
  styleUrls: ['./gb-callout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbCalloutComponent {
  @Input() color?: 'primary' | 'accent' | 'warning' | 'success'
  @Input() title = ''

  constructor() {}
}
